export default {
  fields: {
    sales: {
      label: 'Sprzedaż',
    },
    gift_cards_sales: {
      label: 'Sprzedaż kart podarunkowych',
    },
    average_order_value: {
      label: 'Średnia wartość zamówienia',
    },
    savings: {
      label: 'Oszczędności na opłatach zewnętrznych',
    },
    reservations: {
      label: 'Rezerwacje',
    },
    sales_from_email: {
      label: 'Sprzedaż z e-mail',
    },
    sales_from_google_seo: {
      label: 'Sprzedaż z Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Sprzedaż z Google Business',
    },
    sales_from_google_ads: {
      label: 'Sprzedaż z Google Ads',
    },
    sales_from_flyers: {
      label: 'Sprzedaż z ulotek',
    },
    sales_from_social_media: {
      label: 'Sprzedaż z mediów społecznościowych',
    },
    sales_from_facebook_ads: {
      label: 'Sprzedaż z Facebook Ads',
    },
    tips: {
      label: 'Napiwki',
    },
    new_customers: {
      label: 'Nowi klienci',
    },
    returning_customers: {
      label: 'Powracający klienci',
    },
    new_visitors: {
      label: 'Nowi odwiedzający',
    },
    new_followers: {
      label: 'Nowi obserwatorzy',
    },
    total_followers: {
      label: 'Łączna liczba obserwatorów',
    },
    delivered_messages: {
      label: 'Dostarczone wiadomości',
    },
    average_open_rate: {
      label: 'Średni wskaźnik otwarć e-mail',
    },
    average_click_rate: {
      label: 'Średni wskaźnik kliknięć',
    },
    website_visitors_from_email: {
      label: 'Odwiedzający stronę z e-mail',
    },
    sales_from_google_business: {
      label: 'Sprzedaż z Google Business',
    },
    total_reservations: {
      label: 'Rezerwacje',
    },
    website_visitors_from_google_seo: {
      label: 'Kliknięcia strony z Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Kliknięcia strony z Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Kliknięcia strony z Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Kliknięcia strony z mediów społecznościowych',
    },
    calls_from_google_ads: {
      label: 'Połączenia z Google Ads',
    },
    directions_from_google_ads: {
      label: 'Trasy z Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Media społecznościowe',
    },
    flyer_orders_count: {
      label: 'Ulotki',
    },
    email_orders_count: {
      label: 'E-maile',
    },
    other_orders_count: {
      label: 'Inne',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Karty podarunkowe',
    },
    net_billed_revenue: {
      label: 'Zafakturowany przychód (NET)',
    },
    net_billed_revenue_subscription: {
      label: 'Zafakturowany przychód z subskrypcji',
    },
    net_billed_revenue_service_fee: {
      label: 'Zafakturowany przychód z opłat serwisowych',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Przychód z naliczonych opłat za dostawę',
    },
    net_billed_revenue_other: {
      label: 'Przychód z naliczonych opłat serwisowych',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Naliczona dostawa – przerzut kosztów',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Przychód z naliczonych opłat za obsługę platformy',
    },
    gross_cash_income: {
      label: 'Przychód gotówkowy (brutto)',
    },
    gross_cash_income_subscription: {
      label: 'Przychód gotówkowy z subskrypcji',
    },
    gross_cash_income_service_fee: {
      label: 'Przychód gotówkowy z opłat serwisowych',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Przychód gotówkowy z opłat za dostawę',
    },
    gross_cash_income_other: {
      label: 'Przychód gotówkowy z opłat za obsługę',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Przychód gotówkowy z przerzutowych opłat za dostawę',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Przychód gotówkowy z opłat platformy',
    },
    net_cash_income: {
      label: 'Przychód gotówkowy (netto)',
    },
    net_cash_income_subscription: {
      label: 'Przychód gotówkowy z subskrypcji',
    },
    net_cash_income_service_fee: {
      label: 'Przychód gotówkowy z opłat serwisowych',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Przychód gotówkowy z opłat za dostawę',
    },
    net_cash_income_other: {
      label: 'Przychód gotówkowy z opłat za obsługę',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Przychód gotówkowy z przerzutowych opłat za dostawę',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Przychód gotówkowy z opłat platformy',
    },
    manual_connect_transfers: {
      label: 'Zwroty dla restauracji',
    },
    processing_fees: {
      label: 'Opłaty za obsługę',
    },
    processing_fees_stripe: {
      label: 'Opłaty za obsługę (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Opłaty za obsługę (PayPal)',
    },
    rejected_orders: {
      label: 'Odrzucone zamówienia',
    },
    rejected_orders_amount: {
      label: 'Wartość odrzuconych zamówień',
    },
    rejected_orders_count: {
      label: 'Liczba odrzuconych zamówień',
    },
    rejected_orders_rate: {
      label: 'Wskaźnik odrzuconych zamówień',
    },
    rejected_orders_rate_breakdown: {
      label: 'Podział wskaźnika odrzuceń',
    },
    orders: {
      label: 'Zamówienia',
    },
    total_orders: {
      label: 'Łączna liczba zamówień',
    },
    pickup_orders_rate: {
      label: 'Udział zamówień z odbiorem',
    },
    delivery_orders_rate: {
      label: 'Udział zamówień z dostawą',
    },
    other_orders_rate: {
      label: 'Udział pozostałych zamówień',
    },
    customers: {
      label: 'Łączna liczba klientów',
    },
    customers_auth_state: {
      label: 'Stan uwierzytelnienia klientów',
    },
    website_reservations: {
      label: 'Rezerwacje przez stronę',
    },
    google_reservations: {
      label: 'Rezerwacje Google',
    },
    companies: {
      label: 'Firmy',
    },
    live_companies: {
      label: 'Aktywne restauracje',
    },
    live_companies_percentage: {
      label: 'Odsetek aktywnych restauracji',
    },
    setup_packages_breakdown: {
      label: 'Pakiety startowe',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Pakiety startowe wg źródła rozliczenia',
    },
    crossed_sales_level_this_month: {
      label: 'Przekroczony próg sprzedaży w tym miesiącu',
    },
    crossed_sales_level_total: {
      label: 'Przekroczony próg sprzedaży łącznie',
    },
    crossed_sales_level_percentage: {
      label: 'Odsetek przekroczeń progu sprzedaży',
    },
    has_delivery: {
      label: 'Własna dostawa',
    },
    has_only_pickup: {
      label: 'Tylko odbiór osobisty',
    },
    has_storefront: {
      label: 'Posiada witrynę',
    },
    has_storefront_percentage: {
      label: 'Odsetek witryn',
    },
    use_external_delivery: {
      label: 'Dostawa zewnętrzna',
    },
    crossed_sales: {
      label: 'Przekroczono {{value}} sprzedaży',
    },
    restaurant_partners: {
      label: 'Restauracje partnerskie',
    },
    registered_restaurants: {
      label: 'Zarejestrowane restauracje',
    },
    signed_restaurants: {
      label: 'Restauracje z umową',
    },
    use_reservations: {
      label: 'Korzystają z rezerwacji',
    },
    number: {
      label: 'Liczba',
    },
    restaurants_percentage: {
      label: 'Odsetek restauracji',
    },
    crossed_sales_level: {
      label: 'Przekroczony próg sprzedaży',
    },
    order_method: {
      label: 'Metoda zamówienia',
    },
    own_delivery: {
      label: 'Własna dostawa',
    },
    only_pickup: {
      label: 'Tylko odbiór osobisty',
    },
    storefront: {
      label: 'Witryna',
    },
    sales_tiers: {
      label: 'Progi sprzedaży',
    },
    new_pricing_adoption_rate: {
      label: 'Wskaźnik adopcji nowego cennika',
    },
    mobile_app_attach_rate: {
      label: 'Wskaźnik dołączenia aplikacji mobilnej',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Wybrane opłaty za konfigurację aplikacji',
    },
    first_delivery: {
      label: 'Uber (pierwsza dostawa)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Liczba wycen dostawy',
    },
    deliveries_count: {
      label: 'Liczba dostaw',
    },
    delivery_conversion: {
      label: 'Wskaźnik konwersji dostaw',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Podział wycen dostawy wg dostawcy',
    },
    deliveries_provider_breakdown: {
      label: 'Podział dostaw wg dostawcy',
    },
    delivery_distance_breakdown: {
      label: 'Podział dystansu dostawy',
    },
    total_delivered: {
      label: 'Dostarczone wiadomości',
    },
    website_visitors_from_google_business_profile: {
      label: 'Kliknięcia witryny z Google Business',
    },
    google_business_impressions: {
      label: 'Wyświetlenia z Google Business',
    },
    google_business_website_clicks: {
      label: 'Kliknięcia witryny z Google Business',
    },
    google_ads_impressions: {
      label: 'Wyświetlenia Google Ads',
    },
    google_ads_clicks: {
      label: 'Kliknięcia Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Połączenia Google Ads',
    },
    google_ads_directions: {
      label: 'Trasy Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Śr. % bezwzgl. wyświetleń na szczycie Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Śr. koszt kliknięcia Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Śr. wskaźnik konwersji z interakcji Google Ads',
    },
    website_visits: {
      label: 'Wizyty na stronie',
    },
    website_visitors: {
      label: 'Odwiedzający stronę',
    },
    companies_with_activated_reservations: {
      label: 'Restauracje z aktywowanymi rezerwacjami',
    },
    online_orders_count: {
      label: 'Zamówienia online',
    },
    cash_orders_count: {
      label: 'Zamówienia online',
    },
    cash_sales: {
      label: 'Sprzedaż gotówkowa',
    },
    online_sales: {
      label: 'Sprzedaż online',
    },
    payouts: {
      label: 'Wypłaty',
    },
    last_payout_amount: {
      label: 'Ostatnia wypłata',
    },
    pending_payout_amount: {
      label: 'W drodze',
    },
    future_payout_amount: {
      label: 'Dostępne do przyszłych wypłat',
    },
    mobile_app_average_order_value: {
      label: 'AOV przez aplikację',
    },
    mobile_app_gmv: {
      label: 'Łączna sprzedaż przez aplikację',
    },
    mobile_app_gmv_percentage: {
      label: '% przychodów z aplikacji',
    },
    mobile_app_downloads: {
      label: 'Łączna liczba pobrań aplikacji',
    },
    mobile_app_orders_count: {
      label: 'Łączna liczba zamówień przez aplikację',
    },
    net_billed_revenue_gift_cards: {
      label: 'Przychód z naliczonych kart podarunkowych',
    },
    gross_cash_income_gift_cards: {
      label: 'Przychód gotówkowy z kart podarunkowych',
    },
    net_cash_income_gift_cards: {
      label: 'Przychód gotówkowy z kart podarunkowych',
    },
    platform_processing_fees: {
      label: 'Opłaty za obsługę platformy',
    },
  },
};
